// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { change, reduxForm, formValueSelector } from 'utils/reduxFormWrapper';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import { timeZoneOptions } from 'lib/TimeZones';
import Errors from 'guest_portal/components/Errors'; // Probably should move this to shared, but need a way to distinguish bootstrap from bulma
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Icon from 'shared/components/Icon';
import LoadingContent from 'shared/components/LoadingContent';
import {
  PlainSelectInput,
  RadioGroupInput,
  TextAreaInput,
  TextInput,
} from 'shared/containers/portal_layout/HForm';
import DatePickerInput from 'shared/containers/BulmaFields/DatePickerField';
import TimeMaskInput from 'shared/containers/BulmaFields/TimeMaskField';
import SpinnerButton from 'shared/components/SpinnerButton';
import { required, validAMorPM } from 'utils/validation';
import styles from './QuickAssignOrSchedule.module.scss';
import {
  toDate,
  localDateToISO,
  mmDdYyyy,
} from 'preferral-common/utils/dateFormatters';

const slotLengthOptions = [
  { value: '5', label: '5min slot' },
  { value: '10', label: '10min slot' },
  { value: '15', label: '15min slot' },
  { value: '20', label: '20min slot' },
  { value: '25', label: '25min slot' },
  { value: '30', label: '30min slot' },
  { value: '35', label: '35min slot' },
  { value: '40', label: '40min slot' },
  { value: '45', label: '45min slot' },
  { value: '50', label: '50min slot' },
  { value: '55', label: '55min slot' },
  { value: '60', label: '1hr slot' },
  { value: '65', label: '1hr5min slot' },
  { value: '70', label: '1hr10min slot' },
  { value: '75', label: '1hr15min slot' },
  { value: '80', label: '1hr20min slot' },
  { value: '85', label: '1hr25min slot' },
  { value: '90', label: '1hr30min slot' },
  { value: '95', label: '1hr35min slot' },
  { value: '100', label: '1hr40min slot' },
  { value: '105', label: '1hr45min slot' },
  { value: '110', label: '1hr50min slot' },
  { value: '115', label: '1hr55min slot' },
  { value: '120', label: '2hr slot' },
];

class QuickAssignOrSchedule extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      submittingLocation: false,
      submittingProvider: false,
      submittingReceivingPatientMember: false,
      fetchingReferralId: null,
      locations: null,
      providerMappings: null,
      initialProviderId: null,
      initialLocationId: null,
      initialProviderEmploymentId: null,
      booked: null,
      appointment: null,
      appointmentSlots: null,
      timeZoneName: null,
      fetchingLocationId: null,
    };
    this.fetchProviderMappings = this.fetchProviderMappings.bind(this);
    this.saveLocation = this.saveLocation.bind(this);
    this.saveProvider = this.saveProvider.bind(this);
    this.saveReceivingPatientMember =
      this.saveReceivingPatientMember.bind(this);
    this.unassignLocation = this.unassignLocation.bind(this);
    this.unassignProvider = this.unassignProvider.bind(this);
    this.createSlotAndAppointment = this.createSlotAndAppointment.bind(this);
    // this.createAppointment = this.createAppointment.bind(this);
  }

  componentDidMount() {
    this.fetchReferralData(this.props.referralId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.referralId !== this.props.referralId) {
      this.fetchReferralData(this.props.referralId);
    }
  }

  fetchReferralData(referralId) {
    this.setState({ fetchingReferralId: referralId });
    api
      .get(`${this.props.apiEndpoint}/referrals/${referralId}/quick_scheduler`)
      .then((response) => {
        if (referralId === this.state.fetchingReferralId) {
          this.setState({
            receivingOrganizationId: response.data.receivingOrganizationId,
            referralProfileId: response.data.referralProfileId,
            providerMappings: response.data.providerMappings,
            locations: response.data.locations,
            appointmentSlots: response.data.appointmentSlots,
            initialProviderId: response.data.initialProviderId,
            initialProviderName: response.data.initialProviderName,
            initialLocationId: response.data.initialLocationId,
            initialLocationName: response.data.initialLocationName,
            initialProviderEmploymentId:
              response.data.initialProviderEmploymentId,
            canUpdateReceivingPatientMember:
              response.data.canUpdateReceivingPatientMember,
            receivingPatientMemberId: response.data.receivingPatientMemberId,
            receivingPatientMemberMrn: response.data.receivingPatientMemberMrn,
            fetchingReferralId: null,
            booked: response.data.booked,
            appointment: response.data.appointment,
            timeZoneName: response.data.timeZoneName,
          });
        }
      });
  }

  /**
   * Triggered by selecting a location. Fetches the providers for that location.
   *
   * @param {string} locationId
   */
  fetchProviderMappings(locationId) {
    this.setState({ fetchingLocationId: locationId });
    const { apiEndpoint, referralId } = this.props;
    return api
      .get(
        `${apiEndpoint}/referrals/${referralId}/quick_scheduler?location_id=${locationId}`
      )
      .then((response) => {
        const { fetchingLocationId } = this.state;
        if (fetchingLocationId === locationId) {
          this.setState({
            providerMappings: response.data.providerMappings,
            fetchingLocationId: null,
          });
        }
      });
  }

  saveLocation(locationId) {
    const { apiEndpoint, referralId, handleSuccess } = this.props;

    this.setState({ submittingLocation: true });
    return api
      .put(`${apiEndpoint}/referrals/${referralId}/location_assignment`, {
        location_id: locationId,
      })
      .then((response) => {
        this.setState({ submittingLocation: false });
        handleSuccess(response.data.id);
        FlashMessageActions.flashSuccess({
          message:
            'You have successfully assigned a location for this referral',
        });
      });
  }

  saveProvider(providerEmploymentId) {
    const { apiEndpoint, referralId, handleSuccess } = this.props;
    const { providerMappings } = this.state;

    // We _could_ change the provider select to have values be providerMappingId rather than providerEmploymentId, but it would require changing quite a bit of code behind `slots_with_appointments_controller#create`.
    const providerMappingId = providerMappings.find(
      (pm) => pm.providerEmploymentId === providerEmploymentId
    ).id;

    // REVIEW: It seems almost accidental that `this.state.providerMappings` only contains providerMappings for currently selected location (possibly a race condition on that as well), and if we do `providerMappings.find(pm => pm.providerEmploymentId === providerEmploymentId)` it seems like there could be a chance we end up with a mapping that has the wrong location
    this.setState({ submittingProvider: true });
    return api
      .put(`${apiEndpoint}/referrals/${referralId}/provider_assignment`, {
        provider_mapping_id: providerMappingId,
      })
      .then((response) => {
        this.setState({ submittingProvider: false });
        handleSuccess(response.data.id);
        FlashMessageActions.flashSuccess({
          message:
            'You have successfully assigned a provider for this referral',
        });
      });
  }

  saveReceivingPatientMember(receivingPatientMedicalRecordNumber) {
    const { apiEndpoint, handleSuccess } = this.props;
    const { receivingPatientMemberId } = this.state;

    this.setState({ submittingReceivingPatientMember: true });
    return api
      .put(`${apiEndpoint}/patient_members/${receivingPatientMemberId}`, {
        patient_member: {
          medical_record_number: receivingPatientMedicalRecordNumber,
        },
      })
      .then((response) => {
        this.setState({ submittingReceivingPatientMember: false });
        handleSuccess();
        FlashMessageActions.flashSuccess({
          message:
            'You have successfully updated patient info for this referral',
        });
      });
  }

  unassignLocation() {
    const { apiEndpoint, referralId, handleSuccess } = this.props;
    this.setState({ submittingLocation: true });
    return api
      .delete(`${apiEndpoint}/referrals/${referralId}/location_assignment`)
      .then((response) => {
        this.setState({ submittingLocation: false });
        handleSuccess();
        FlashMessageActions.flashSuccess({
          message:
            'You have successfully removed the assigned location for this referral',
        });
      });
  }

  unassignProvider() {
    const { apiEndpoint, referralId, handleSuccess } = this.props;
    this.setState({ submittingProvider: true });
    return api
      .delete(`${apiEndpoint}/referrals/${referralId}/provider_assignment`)
      .then((response) => {
        this.setState({ submittingProvider: false });
        handleSuccess();
        FlashMessageActions.flashSuccess({
          message:
            'You have successfully unassigned the provider for this referral',
        });
      });
  }

  /**
   * This is called by "Pick Time"
   */
  // createAppointment(formValues) {
  //   return api
  //     .post(
  //       `${this.props.apiEndpoint}/referrals/${this.props.referralId}/appointments`,
  //       decamelizeKeys(formValues)
  //     )
  //     .then(response => {
  //       this.props.handleSuccess(response.data.transferredToId);
  //       FlashMessageActions.flashSuccess({
  //         message: 'You have successfully created an appointment for this referral',
  //       });
  //     });
  // }

  /**
   * This is called by "Give Time"
   */
  createSlotAndAppointment(formValues) {
    const { apiEndpoint, referralId } = this.props;
    const input = {
      ...formValues,
      slotAttributes: {
        ...formValues.slotAttributes,
        startDate: mmDdYyyy(formValues.slotAttributes.startDate),
      },
    };

    return api
      .post(
        `${apiEndpoint}/referrals/${referralId}/slots_with_appointments`,
        decamelizeKeys(input)
      )
      .then((response) => {
        this.props.handleSuccess(response.data.id);
        FlashMessageActions.flashSuccess({
          message:
            'You have successfully created an appointment for this referral',
        });
        return null;
      });
  }

  render() {
    return (
      <div className={cx(styles.Modal)} style={{ minWidth: 712 }}>
        <div className={styles.Modal__header}>
          <h1>
            {this.state.booked ? 'Reassign / Reschedule' : 'Assign / Schedule'}
          </h1>
        </div>
        {!this.state.locations ? (
          <div style={{ padding: '3rem 2rem' }}>
            <LoadingContent className={styles.loading_content} />
          </div>
        ) : (
          <FormifiedPresentationComponent
            form="assignOrScheduleForm"
            initialValues={{
              slotAttributes: {
                startDate: this.state.appointment
                  ? toDate(localDateToISO(this.state.appointment.startDate))
                  : '',
                startTime: this.state.appointment
                  ? this.state.appointment.startTime
                  : '',
                timeZoneName: this.state.timeZoneName,
                locationId: this.state.initialLocationId,
                providerEmploymentId: this.state.initialProviderEmploymentId,
                duration: '30',
              },
              pickTime: {
                locationId: this.state.initialLocationId,
                providerId: this.state.initialProviderId,
              },
              receivingPatientMember: {
                medicalRecordNumber: this.state.receivingPatientMemberMrn,
              },
              rescheduleParams: {},
            }}
            receivingOrganizationId={this.state.receivingOrganizationId}
            receivingPatientMemberId={this.state.receivingPatientMemberId}
            canUpdateReceivingPatientMember={
              this.state.canUpdateReceivingPatientMember
            }
            initialLocationId={this.state.initialLocationId}
            initialLocationName={this.state.initialLocationName}
            initialProviderEmploymentId={this.state.initialProviderEmploymentId}
            initialProviderName={this.state.initialProviderName}
            providerMappings={this.state.providerMappings}
            locations={this.state.locations}
            appointmentSlot={this.state.appointmentSlots}
            isLoading={!this.state.locations}
            booked={this.state.booked}
            onLocationChange={this.fetchProviderMappings}
            saveLocation={this.saveLocation}
            saveProvider={this.saveProvider}
            saveReceivingPatientMember={this.saveReceivingPatientMember}
            unassignLocation={this.unassignLocation}
            unassignProvider={this.unassignProvider}
            submittingLocation={this.state.submittingLocation}
            submittingProvider={this.state.submittingProvider}
            // createAppointment={this.createAppointment}
            createSlotAndAppointment={this.createSlotAndAppointment}
            allowGiveTime={this.props.allowGiveTime}
            webpageBase={this.props.webpageBase}
            apiEndpoint={this.props.apiEndpoint}
            referralId={this.props.referralId}
            referralProfileId={this.state.referralProfileId}
          />
        )}
      </div>
    );
  }
}

QuickAssignOrSchedule.propTypes = {
  referralId: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  apiEndpoint: PropTypes.string.isRequired,
  allowGiveTime: PropTypes.bool.isRequired,
};

const PresentationComponent = (props) => {
  /**
   * Can unassign location only if:
   *  - location is assigned, and
   *  - provider is not assigned.
   */
  const canUnassignLocation =
    !!props.initialLocationId && !props.initialProviderEmploymentId;

  /**
   * Can unassign provider only if:
   *  - provider is assigned, and
   *  - appointment is not scheduled.
   */
  const canUnassignProvider =
    !!props.initialProviderEmploymentId && !props.booked;

  /**
   * Can update location only if:
   *  - provider is not assigned
   *  - selected location is different from currently assigned location
   */
  const canUpdateLocation =
    props.selectedLocationId &&
    !props.initialProviderEmploymentId &&
    props.initialLocationId !== props.selectedLocationId;

  /**
   * Can update provider only if:
   *  - appointment is not booked
   *  - selected provider is different from currently assigned provider
   */
  const canUpdateProvider =
    props.selectedProviderEmploymentId &&
    !props.booked &&
    (props.initialProviderEmploymentId !== props.selectedProviderEmploymentId ||
      props.initialLocationId !== props.selectedLocationId);

  /**
   * Can update receivingPatientMember only if:
   *  - is the receiving office
   */
  const canUpdateReceivingPatientMember =
    !!props.canUpdateReceivingPatientMember;

  return (
    <div>
      <div style={{ padding: '3rem 2rem 1.5rem' }}>
        <Errors errors={props.error || []} />
        <div>
          {canUpdateReceivingPatientMember && (
            <div>
              <div
                className="field is-horizontal"
                style={{ marginBottom: '1rem' }}
              >
                <div
                  className="field-label is-normal"
                  style={{ flexGrow: 1.5 }}
                >
                  <label className="bulma__label" />
                </div>
                <div className="field-body">
                  <h4 className={styles.form_section_header}>Patient</h4>
                </div>
              </div>
              <div
                className="field is-horizontal"
                style={{ marginBottom: '2rem' }}
              >
                <div
                  className="field-label is-normal"
                  style={{ flexGrow: 1.5 }}
                >
                  <label className="bulma__label">Patient MRN</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <div className="control">
                      <TextInput
                        className="input bulma__input"
                        name="receivingPatientMember.medicalRecordNumber"
                        placeholder="MRN"
                      />
                    </div>
                  </div>

                  {!!props.receivingPatientMemberId && (
                    <div className="field" style={{ flexGrow: 0 }}>
                      <div
                        className="control"
                        data-spec-id="save-location-control"
                      >
                        <button
                          disabled={
                            !canUpdateReceivingPatientMember ||
                            props.submittingReceivingPatientMember ||
                            props.submitting
                          }
                          className={cx('button is-outlined is-link', {
                            'is-loading':
                              props.submittingLocation || props.submitting,
                          })}
                          onClick={() =>
                            props.saveReceivingPatientMember(
                              props.receivingPatientMemberMrn
                            )
                          }
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="field is-horizontal" style={{ marginBottom: '1rem' }}>
            <div className="field-label is-normal" style={{ flexGrow: 1.5 }}>
              <label className="bulma__label" />
            </div>
            <div className="field-body">
              <h4 className={styles.form_section_header}>
                Location {'&'} Provider
              </h4>
              <h4 className={styles.form_section_header} style={{ flex: 1 }}>
                <Link
                  to={`${props.webpageBase}/referral_profiles/${props.referralProfileId}/referral_dashboard?network_id=${props.receivingOrganizationId}`}
                >
                  Use Provider Search <Icon name="search" />
                </Link>
              </h4>
            </div>
          </div>

          <div
            className="field is-horizontal"
            style={{ marginBottom: '0.5rem' }}
          >
            <div className="field-label is-normal" style={{ flexGrow: 1.5 }}>
              <label className="bulma__label">Location</label>
            </div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <div className="select is-fullwidth">
                    <PlainSelectInput
                      name="slotAttributes.locationId"
                      options={props.locations}
                      onChange={(locationId) => {
                        props.onLocationChange(locationId);
                        props.dispatch(
                          change(
                            props.form,
                            'slotAttributes.providerEmploymentId',
                            null
                          )
                        );
                      }}
                      labelKey="name"
                      valueKey="id"
                      disabled={props.submittingLocation || props.submitting}
                    />
                    {/* <select>
                      <option>Select...</option>
                      <option>NashCare - Brentwood</option>
                      <option>NashCare - Smyrna</option>
                    </select> */}
                  </div>
                </div>
                {!props.initialLocationId ? (
                  <p className={cx('help has-text-left', styles.warning)}>
                    No Location Assigned
                  </p>
                ) : (
                  <p className="help has-text-left" style={{ color: 'grey' }}>
                    Current Location: {props.initialLocationName}
                    {canUnassignLocation && (
                      <a
                        className="has-text-danger"
                        style={{ marginLeft: '0.75em' }}
                        onClick={props.unassignLocation}
                      >
                        Unassign
                      </a>
                    )}
                  </p>
                )}
              </div>

              <div className="field" style={{ flexGrow: 0 }}>
                <div className="control" data-spec-id="save-location-control">
                  <button
                    disabled={
                      !canUpdateLocation ||
                      props.submittingLocation ||
                      props.submitting
                    }
                    className={cx('button is-outlined is-link', {
                      'is-loading':
                        props.submittingLocation || props.submitting,
                    })}
                    onClick={() => props.saveLocation(props.selectedLocationId)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="field is-horizontal" style={{ marginBottom: '2rem' }}>
            <div className="field-label is-normal" style={{ flexGrow: 1.5 }}>
              <label className="bulma__label">Provider</label>
            </div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <div className="select is-fullwidth">
                    <PlainSelectInput
                      name="slotAttributes.providerEmploymentId"
                      options={props.providerMappings}
                      labelKey="name"
                      valueKey="providerEmploymentId"
                      disabled={props.submittingProvider || props.submitting}
                    />
                  </div>
                </div>
                {!props.initialProviderEmploymentId ? (
                  <p className={cx('help has-text-left', styles.warning)}>
                    No Provider Assigned
                  </p>
                ) : (
                  <p className="help has-text-left" style={{ color: 'grey' }}>
                    Current Provider: {props.initialProviderName}
                    {canUnassignProvider && (
                      <a
                        className="has-text-danger"
                        style={{ marginLeft: '0.75em' }}
                        onClick={props.unassignProvider}
                      >
                        Unassign
                      </a>
                    )}
                  </p>
                )}
              </div>

              <div className="field" style={{ flexGrow: 0 }}>
                <div className="control" data-spec-id="save-provider-control">
                  <button
                    disabled={
                      !canUpdateProvider ||
                      props.submittingProvider ||
                      props.submitting
                    }
                    className={cx('button is-outlined is-link', {
                      'is-loading':
                        props.submittingProvider || props.submitting,
                    })}
                    onClick={() =>
                      props.saveProvider(props.selectedProviderEmploymentId)
                    }
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="field is-horizontal"
            style={{ marginBottom: props.booked ? '0.5rem' : '1rem' }}
          >
            <div className="field-label is-normal" style={{ flexGrow: 1.5 }}>
              <label className="bulma__label" />
            </div>
            <div className="field-body">
              <h4 className={styles.form_section_header}>Appointment</h4>
            </div>
          </div>

          <div
            className="field is-horizontal"
            style={{ marginBottom: '1.25rem' }}
          >
            <div className="field-label is-normal" style={{ flexGrow: 1.5 }}>
              <label className="bulma__label">Appointment Time</label>
            </div>
            <div className="field-body">
              <div className="field">
                <DatePickerInput
                  className="input bulma__input"
                  name="slotAttributes.startDate"
                  validate={required}
                />
                <div>
                  <PlainSelectInput
                    name="slotAttributes.timeZoneName"
                    className={styles.select_help_text}
                    style={{ float: 'right' }}
                    options={timeZoneOptions}
                    prompt={false}
                  />
                </div>
              </div>
              <div className="field">
                <TimeMaskInput
                  name="slotAttributes.startTime"
                  validate={[required, validAMorPM]}
                />
                <div>
                  <PlainSelectInput
                    name="slotAttributes.duration"
                    className={styles.select_help_text}
                    style={{ float: 'left' }}
                    options={slotLengthOptions}
                    prompt={false}
                  />
                </div>
              </div>
            </div>
          </div>

          {props.booked && (
            <div
              className="field is-horizontal"
              style={{
                marginBottom: !!props.selectedExistingAppointmentChoice
                  ? '0.5rem'
                  : '1rem',
              }}
            >
              <div className="field-label" style={{ flexGrow: 1.5 }}>
                <label className="bulma__label">
                  Handle Existing Appointment
                </label>
              </div>
              <div className="field-body">
                <div className={cx('control', styles.radio_field)}>
                  <RadioGroupInput
                    name="rescheduleParams.existingAppointmentChoice"
                    options={[
                      { value: 'cancel', label: 'Cancel' },
                      { value: 'noshow', label: "Mark as 'No Show'" },
                    ]}
                  />
                </div>
              </div>
            </div>
          )}

          {!!props.selectedExistingAppointmentChoice && (
            <div
              className="field is-horizontal"
              style={{ marginBottom: '1rem' }}
            >
              <div className="field-label is-normal" style={{ flexGrow: 1.5 }}>
                <label className="bulma__label">
                  {props.selectedExistingAppointmentChoice === 'cancel'
                    ? 'Cancellation Reason'
                    : 'No Show Reason'}
                </label>
              </div>
              <div className="field-body">
                <div className="field">
                  <div className="control">
                    <TextAreaInput
                      className="textarea"
                      name="rescheduleParams.reason"
                      placeholder={
                        props.selectedExistingAppointmentChoice === 'cancel'
                          ? 'Cancellation Reason'
                          : 'No Show Reason'
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.Modal__footer}>
        <SpinnerButton
          type="submit"
          loading={props.submitting}
          className="button is-primary"
          onClick={props.handleSubmit(props.createSlotAndAppointment)}
        >
          Save All
        </SpinnerButton>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    locationId: selectedLocationId,
    providerEmploymentId: selectedProviderEmploymentId,
  } = formValueSelector('assignOrScheduleForm')(state, 'slotAttributes');
  const { existingAppointmentChoice: selectedExistingAppointmentChoice } =
    formValueSelector('assignOrScheduleForm')(state, 'rescheduleParams');
  const { medicalRecordNumber: receivingPatientMemberMrn } = formValueSelector(
    'assignOrScheduleForm'
  )(state, 'receivingPatientMember');
  return {
    selectedLocationId,
    selectedProviderEmploymentId,
    selectedExistingAppointmentChoice,
    receivingPatientMemberMrn,
  };
};

const FormifiedPresentationComponent = reduxForm({})(
  connect(mapStateToProps)(PresentationComponent)
);

export default QuickAssignOrSchedule;
